import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { contabilidadeDigitalAuthorize } from '@ibk/shared-assets';
import { useTranslation } from '@ibk/shared-translation';
import { AppDomain } from '@ibk/shared-types';
import { LandingPageBase } from './LandigPageBase/LandingPageBase';
const featuresList = [
    {
        icon: 'arrowsRotate',
        translationKey: 'contabilidade-digital.landing.empresa.feature-1',
    },
    {
        icon: 'listCheck',
        translationKey: 'contabilidade-digital.landing.empresa.feature-2',
    },
    {
        icon: 'bank',
        translationKey: 'contabilidade-digital.landing.empresa.feature-3',
    },
];
export const LandingPageEmpresa = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (_jsx(LandingPageBase, { image: contabilidadeDigitalAuthorize, title: t('contabilidade-digital.landing.empresa.title'), subtitle: t('contabilidade-digital.landing.empresa.subtitle'), mainTitle: t('contabilidade-digital.landing.empresa.main-title'), featuresList: featuresList, buttonText: t('contabilidade-digital.landing.empresa.cta-button'), buttonClickHandler: () => {
            navigate('/contabilidade-digital/contas-conectadas?open-finance=true', { replace: true });
        }, domain: AppDomain.EMPRESA }));
};
